// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"invoice_pageContainer__1wsUH","header":"invoice_header__1smEZ","wrapper":"invoice_wrapper__1iPOm"};